import { useEffect, useState } from 'react';
import { SEOHead } from '../../components/seo/SEOHead';
import { DashboardWidget } from '../../components/admin/DashboardWidget';
import { Spinner } from '../../components/ui/Card';
import { api } from '../../lib/api';
import type { AdminDashboardStats } from '@bharat-consultancy/shared';

export default function AdminDashboard() {
  const [stats, setStats] = useState<AdminDashboardStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.admin
      .dashboard()
      .then((res) => setStats(res.stats))
      .catch(() => setError('Could not load dashboard stats.'))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <>
      <SEOHead title="Admin Dashboard — Bharat Consultancy" description="" canonicalPath="/admin" />

      <h1 className="font-display text-2xl font-bold text-ink">Dashboard</h1>

      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}

      {isLoading ? (
        <div className="mt-8 flex justify-center">
          <Spinner className="h-8 w-8 text-seal-blue" />
        </div>
      ) : stats ? (
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <DashboardWidget label="Total Customers" value={stats.totalCustomers} />
          <DashboardWidget label="Total Orders" value={stats.totalOrders} />
          <DashboardWidget label="Today's Orders" value={stats.todaysOrders} accent="gold" />
          <DashboardWidget label="Revenue" value={`₹${stats.revenue.toLocaleString('en-IN')}`} accent="green" />
          <DashboardWidget label="Pending Orders" value={stats.pendingOrders} />
          <DashboardWidget label="Completed Orders" value={stats.completedOrders} accent="green" />
        </div>
      ) : null}
    </>
  );
}
